// По ТЗ 03.09.2026: API для типовых распорядков и сохранённых расписаний
// на сутки (боевой расчёт).

import { http } from './http'

// --- Типовые распорядки (шаблоны) ---

export async function listRoutineTemplates() {
  const { data } = await http.get('chpo/routine-templates/')
  return Array.isArray(data) ? data : (data?.results || [])
}

export async function getRoutineTemplate(id) {
  const { data } = await http.get(`chpo/routine-templates/${id}/`)
  return data
}

export async function createRoutineTemplate(payload) {
  const { data } = await http.post('chpo/routine-templates/', payload)
  return data
}

export async function updateRoutineTemplate(id, payload) {
  const { data } = await http.patch(`chpo/routine-templates/${id}/`, payload)
  return data
}

export async function deleteRoutineTemplate(id) {
  await http.delete(`chpo/routine-templates/${id}/`)
}

export async function getActiveRoutineTemplate() {
  const all = await listRoutineTemplates()
  return all.find(t => t.is_active) || all[0] || null
}

// --- Слоты шаблона ---

export async function createRoutineSlot(payload) {
  const { data } = await http.post('chpo/routine-slots/', payload)
  return data
}

export async function updateRoutineSlot(id, payload) {
  const { data } = await http.patch(`chpo/routine-slots/${id}/`, payload)
  return data
}

export async function deleteRoutineSlot(id) {
  await http.delete(`chpo/routine-slots/${id}/`)
}

// --- Сохранённые расписания на дату ---

export async function listSchedules(params = {}) {
  const { data } = await http.get('chpo/daily-schedules/', { params })
  return Array.isArray(data) ? data : (data?.results || [])
}

export async function upsertSchedule(payload) {
  // payload = { chpo, user, slots_json }
  // Пытаемся обновить существующий, если нет — создаём.
  const existing = await listSchedules({ chpo: payload.chpo, user: payload.user })
  if (existing.length > 0) {
    const { data } = await http.patch(`chpo/daily-schedules/${existing[0].id}/`, {
      slots_json: payload.slots_json,
    })
    return data
  }
  const { data } = await http.post('chpo/daily-schedules/', payload)
  return data
}
